import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {DialogsOverviewComponent} from './dialogs-overview.component';

const routes: Routes = [
  {path: 'dialogs', component: DialogsOverviewComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class DialogsOverviewRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-overview/dialogs-overview-routing.module.ts